
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {
    isLoading: false,
    isError: false,
    message:null,
    userData: null,
    userDocImage : null,

    isLoadingUserComments: false, 
    userComments: [],

    selectUserData:null
}


export const getUserData = createAsyncThunk("user/getUserData", async(userName,thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/user/DocumentIsThere?phoneNumber=${userName}`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const getUserComments = createAsyncThunk("user/getUserComments", async({userId,page},thunkApi)=> {
    try {

        const {data} = await axiosInstance.get(`/Shipment/GetRateAndCommentOfTruckerShipmentForProfilePage?userId=${userId}&&pageSayi=${page}`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})



const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        getUserDocImage: (state,action) => {
            state.userDocImage = action.payload
        },
        clearUserState: (state) => {
            return initialState
        },

        setSelectUserData:(state,action) => {
            state.selectUserData = action.payload
        }
    },
    extraReducers:(builder)=> {
        builder
        // getUserData
        .addCase(getUserData.pending, (state)=> {
            state.isLoading = true
        })

        .addCase(getUserData.fulfilled, (state, action)=> {
            state.isLoading = false
            state.userData = action.payload.data
        })

        .addCase(getUserData.rejected, (state, action)=> {
            state.isLoading = false
            state.isError = true
        })

        // get User comments
        .addCase(getUserComments.pending, (state)=> {
            state.isLoadingUserComments = true
        })

        .addCase(getUserComments.fulfilled, (state, action)=> {
            state.isLoadingUserComments = false
            state.userComments = action.payload.data.$values
        })

        .addCase(getUserComments.rejected, (state, action)=> {
            state.isLoadingUserComments = false
            state.isError = true
        })
   
    }
})


export const {getUserDocImage,clearUserState,setSelectUserData} = userSlice.actions
export default userSlice.reducer